import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, getTextColor, drawRectangle, getTrimmedText} from '../../canvas-timeline/canvas_timeline_util';
import Util from '../../../../forecast-app/shared/util/util';
class ProjectItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PROJECT_SCHEDULING_PROJECT, data);
	}

	draw(canvasContext, x, y, width, canvasWidth) {
		const {data, height} = this;
		const {isHourEstimated, color, isPlanning, planningText, intl, project, projects, useNewProgressCalculation} = data;
		let completion;
		if (project) {
			completion = project.completion && project.completion > 0 ? Math.floor(project.completion) : 0;
		} else {
			if (useNewProgressCalculation) {
				let doneForecast = 0;
				let reportedNotDone = 0;
				let remaining = 0;
				let doneTaskCount = 0;
				let totalTaskCount = 0;
				for (const projectInGroup of projects) {
					doneForecast += projectInGroup.doneForecastMinutes;
					reportedNotDone += projectInGroup.reportedNotDone;
					remaining += projectInGroup.remainingMinutes;
					doneTaskCount += projectInGroup.doneTasksCount;
					totalTaskCount += projectInGroup.tasksCount;
				}
				completion = Math.round(Util.calculateTaskGroupCompletion(doneForecast, reportedNotDone, remaining, doneTaskCount, totalTaskCount) * 100);
			} else {
				let forecast = 0;
				let reported = 0;
				let remaining = 0;
				let totalTasksCount = 0;
				let doneTasksCount = 0;
				let factor = null;
				for (const projectInGroup of projects) {
					if (isHourEstimated === false && factor === null) {
						factor = projectInGroup.minutesPerEstimationPoint;
					}
					forecast += projectInGroup.forecast;
					reported += projectInGroup.reported;
					remaining += projectInGroup.remaining;
					totalTasksCount += projectInGroup.tasksCount;
					doneTasksCount += projectInGroup.doneTasksCount;
				}
				completion = Util.deprecated_calculateElementProgress(forecast, reported, remaining, totalTasksCount, doneTasksCount, isHourEstimated, factor);
			}
		}

		let remaining;
		if (project) {
			remaining = project.remaining && project.remaining > 0 ? project.remaining : 0;
		} else {
			remaining = projects.reduce((total, project) => total + project.remaining, 0);
		}

		const textColor = getTextColor(isPlanning ? '#ffffff' : color);
		//Draw background colored rectangle
		const options = {
			backgroundColor: isPlanning ? '#ffffff' : color,
			backgroundOpacity: isPlanning || completion === 100 ? 1 : 0.7,
			borderRadius: 10,
			borderThickness: isPlanning ? 2 : undefined,
			borderColor: isPlanning ? color : undefined,
		};
		drawRectangle(canvasContext, x, y, width, height, options);

		const textMargin = 16;
		const minimumTrim = 45;
		const middlePadding = 16;

		const visibleRightX = x + width > canvasWidth ? canvasWidth : x + width;
		const visibleLeftX = x > 0 ? x : 0;
		const visibleItemWidth = visibleRightX - visibleLeftX;

		const textTrim = visibleItemWidth - textMargin * 2;

		canvasContext.font = '14px ' + Util.getFontFamily();
		let projectName = '';
		if (project) {
			projectName = project.name;
		}
		const projectNameTextWidth = canvasContext.measureText(projectName).width;

		let hoursLeftString;
		let rightSize;

		if (isPlanning) {
			canvasContext.font = '14px ' + Util.getFontFamily();
			rightSize = canvasContext.measureText(planningText).width;
		} else {
			if (isHourEstimated) {
				hoursLeftString = Util.convertMinutesToFullHour(remaining, intl);
			} else {
				hoursLeftString = intl.formatMessage({id: 'common.x_points'}, {points: remaining});
			}
			hoursLeftString += ` ${intl.formatMessage({id: 'common.left'}).toLowerCase()}`;
			canvasContext.font = '500 10px ' + Util.getFontFamily();
			rightSize = canvasContext.measureText(hoursLeftString).width;
		}

		const showLeft = textTrim > minimumTrim || projectNameTextWidth < minimumTrim;
		const showRight = visibleItemWidth - (rightSize + textMargin + middlePadding) > projectNameTextWidth;

		if (!showLeft && !showRight) {
			return;
		}

		if (!isPlanning) {
			//Draw progress bar if needed
			if (completion !== 0 && completion !== 100) {
				//The last path drawn is the shape of item, use that as a clipping path to draw progress
				canvasContext.save();
				canvasContext.clip();
				//draw completion rectangle
				const completionRecOptions = {
					backgroundColor: color,
				};
				const progressWidth = (width * completion) / 100;
				drawRectangle(canvasContext, x, y, progressWidth, height, completionRecOptions);
				canvasContext.restore();
			}
		}

		//Planning projects just have the planning text on them
		if (showRight) {
			if (isPlanning) {
				canvasContext.fillStyle = '#535353';
				canvasContext.font = '14px ' + Util.getFontFamily();
				canvasContext.fillText(planningText, visibleRightX - textMargin - rightSize, y + 24);
			} else {
				const completionString = `${completion}%`;
				canvasContext.font = '700 12px ' + Util.getFontFamily();
				const completionStringWidth = canvasContext.measureText(completionString).width;
				if (project && !project.noCompletionData) {
					canvasContext.fillStyle = textColor;
					canvasContext.font = '700 12px ' + Util.getFontFamily();
					canvasContext.fillText(completionString, visibleRightX - textMargin - completionStringWidth, y + 17);
					canvasContext.font = '500 10px ' + Util.getFontFamily();
					canvasContext.fillText(hoursLeftString, visibleRightX - textMargin - rightSize, y + 30);
				}
			}
		}

		//Project Name
		if (showLeft) {
			canvasContext.fillStyle = textColor;
			canvasContext.font = '14px ' + Util.getFontFamily();
			canvasContext.fillText(getTrimmedText(canvasContext, projectName, textTrim), textMargin + visibleLeftX, y + 24);
		}
	}
}
export default ProjectItem;
